// extracted by mini-css-extract-plugin
export default {"main":"brandbar_main__gdW2-","img":"brandbar_img__gL7MS","item":"brandbar_item__fMix9","title":"brandbar_title__bwFZM"};